<template>
  <div class="booking-screen">
    <layout-report-with-banner
      :isProgressDone="true"
      :showProgress="false"
      :showFooter="true"
      :showLoginButton="showLoginButton"
    >
      <template v-if="!isMobile && bookingProcessStep == bookingStepEnum.START" v-slot:banner>
        <v-img :src="headerImage" height="450">
          <v-overlay value="true" absolute>
            <v-container class="mx-auto">
              <v-row>
                <v-col cols="12">
                  <h2 class="text-md-h2 text-sm-h3 text-h4 font-weight-medium mt-sm-8 mt-md-0">
                    {{ $t("bookingForm.BookingStart.introText") }}
                  </h2>
                </v-col>
                <v-col cols="12">
                  <h4 class="text-md-h4 text-sm-h5 text-h6 font-weight-medium mt-sm-8 mt-md-0">
                    {{ $t("bookingForm.BookingStart.introSubText") }}
                  </h4>
                </v-col>
              </v-row>
              <div class="text-caption mb-4 mt-4 mx-4">
                <v-icon small>mdi-shield-check</v-icon> {{ $t("report.trustBanner.privacy") }}
                <v-icon small>mdi-lock</v-icon> {{ $t("report.trustBanner.encryption") }}
                <v-icon small>mdi-check-decagram</v-icon>
                {{ $t("report.trustBanner.datacenter") }}
              </div>
              <div class="text-caption mb-4 mt-4 mx-4">
                {{ partner.companyName }} -

                <span v-if="partner.address" class="ml-1">
                  {{ partner.address.street }},
                  {{ partner.address.zip }}
                  {{ partner.address.city }}
                </span>
              </div>
            </v-container>
          </v-overlay>
        </v-img>

        <booking-start-how-to-book />
      </template>
      <template v-slot:content>
        <booking-process flat />

        <query-params-list></query-params-list>
      </template>
    </layout-report-with-banner>
  </div>
</template>

<script lang="ts">
import BookingProcess from "@/components/booking/customer/BookingProcess.vue";
import BookingStart from "@/components/booking/customer/BookingStart.vue";
import BookingStartHowToBook from "@/components/booking/customer/BookingStartHowToBook.vue";
import Debug from "@/components/utility/Debug.vue";
import ErrorCard from "@/components/utility/ErrorCard.vue";
import LayoutReportWithBanner from "@/layouts/LayoutReportWithBanner.vue";
import { Component, Vue } from "vue-property-decorator";
import { PartnerModule } from "@/store/modules/partner";
import { AvailabilityModule } from "@/store/modules/availability.store";
import { BookingStepEnum } from "@/store/enum/bookingScreenEnum";
import { UserModule } from "@/store/modules/me-user.store";
import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { ConfigModule } from "@/store/modules/config";
import QueryParamsList from "@/components/settings/QueryParamsList.vue";

@Component({
  components: {
    LayoutReportWithBanner,
    BookingProcess,
    BookingStart,
    BookingStartHowToBook,
    Debug,
    QueryParamsList,
    ErrorCard
  }
})
export default class BookingServiceAvailability extends Vue {
  bookingStepEnum = BookingStepEnum;

  get showLoginButton(): boolean {
    const isCustomerSignup = PartnerModule.partner?.settings?.bookedServices.customer ?? false;
    const isThg = ConfigModule.appContext === AppContextEnum.THG;
    return isThg ? !UserModule.isAuthenticated : !UserModule.isAuthenticated && isCustomerSignup;
  }

  get headerImage() {
    if (PartnerModule?.partner?.settings?.reportSettings?.headerImageUrl) {
      return PartnerModule?.partner?.settings?.reportSettings?.headerImageUrl;
    } else if (PartnerModule?.partner?.settings?.headerImageUrl) {
      return PartnerModule?.partner?.settings?.headerImageUrl;
    } else {
      return "https://static.mmmint.ai/wirkaufendeinethg/header-image.png";
    }
  }

  get bookingProcessStep() {
    return AvailabilityModule.currentStep;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get partner() {
    return PartnerModule.partner;
  }
}
</script>

<style scoped>
.booking-screen {
  position: relative;
}
</style>
